import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentFactoryResolver, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { ShelfAppendDirective } from './directives/shelfAppend.directive';
import { ShelfAppendComponent } from './directives/shelfAppend.component';
import { BookshelfComponent } from './bookshelf/bookshelf.component';
import { AllComponent } from './all/all.component';
import { LoginComponent } from './popups/login/login.component';
import { GoogledriveComponent } from './googleDrive/googledrive/googledrive.component';
import { GoogleSignInSuccess } from 'angular-google-signin';
import { ShelfPouchDb } from './shelf.pouchdb.service'
import { GoogleService } from '../shared/Google.service';
import { MatSnackBar } from '@angular/material';
import { Component_interactionService } from '../component_interaction.service';
import { LoginObservableService } from "../shared/loginObservable.service";
import { InboxComponent } from './inbox/inbox.component';
import { InboxDetailsComponent } from './inboxDetails/inboxDetails.component';
import { PouchdbService } from '../shared/pouchDb.service';
import { DropboxComponent } from './dropbox/dropbox.component';
import { IS_ElectronService } from '../shared/IS_Electron.service';
// import {MouseactionsDirective} from '../shared/mouseactions.directive'

var googleUser = {};
declare var gapi: any;
declare var google: any;
declare var oauthToken: any;
declare var FilePicker: any;
declare var filesdata: any;
var auth2; // The Sign-In object.
var godata;
var datagoogle;
@Component({
  selector: 'app-shelf',
  templateUrl: './shelf.component.html',
  styleUrls: ['./shelf.component.css', '../shared/css/common.css']
})
export class ShelfComponent implements OnInit {
  @Input() data: any
  globalPopupPara = <any>{};

  constructor(public pouchService: PouchdbService, public shelfPouchService: ShelfPouchDb, private viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver, private cdr: ChangeDetectorRef, private GoogleService: GoogleService, public snackBar: MatSnackBar, private Component_interactionService: Component_interactionService, private LoginObservableService: LoginObservableService, private ElectronService: IS_ElectronService) { }

  public displayRecents = false;
  public userDetails;
  public ComponentModel;
  public selectedTabTypeIndex = 0;
  public selectedBottomTabIndex = 0;;
  public selectedTabList;
  public left_headerElements;
  public listOfElememts;
  isLeftnavbarShow = true;
  onBookClicked;
  // message;
  clcikedBookInfo;
  bookParentInfo;
  appendComponent;
  sharedWithMe = false;
  isLoggedIn = false;
  user;
  contacts;
  loginUserDetails;
  answerSheetLength = 0;
  popupParams = {
    height: 400,
    width: 300,
    direction: "left",
    arrowPos: 50,
    showPopup: false,
    isBooksFilter: "country",
    curComp: this
  };
  public left_bottomElements = [{
    "name": "Library",
    "icon": "icon-Content",
    "code": "access_library"
  },
  {
    "name": "Activity",
    "icon": "icon-Tests",
    "code": "Access_activity"
  },
  {
    "name": "Connect",
    "icon": "icon-Connect",
    "code": "Access_Connect"
  },
  {
    "name": "Resources",
    "icon": "icon-Notes",
    "code": "Access_Recourse"
  }];

  toggleAppSearch = false;
  showLiveServer = false;
  displayShelfSearchArea = false;
  searchingBook = '';
  @ViewChild(ShelfAppendDirective) shelfHost: ShelfAppendDirective;
  @ViewChild('googleLogin', { read: ElementRef }) public googleLogin: ElementRef;
  subscription;
  shelfBookSubscription;

  gapi;
  dataSynced;
  syncingDataStatus: any;
  public answerSheetLengthdataSynced: any;
  ngOnInit() {
    var self = this;
    if (localStorage.userData != 'undefined') {

      if (localStorage.userData != undefined) {
        this.userDetails = JSON.parse(localStorage.userData);
        this.loginUserDetails = this.userDetails;
        this.isLoggedIn = true;
      }

    }


    this.subscription = this.Component_interactionService.cast.subscribe(data => {
      if (data.title != undefined) {
        this.onBookClick(data);
      }
    })

    this.displayRecents = localStorage.isCheckedRecents;

    this.dataSynced = this.pouchService.syncingData$.subscribe(data => {

      self.syncingDataStatus = data;

      if (data == 'Data Pulled') {
        self.shelfPouchService.alternateGetShelfData(0);
      }
    })

    this.answerSheetLengthdataSynced = this.Component_interactionService.answerSheetLength$.subscribe(data => {
      console.log(data);
      self.updateanswerSheetLength(data);

    })

    if (localStorage.appServer == 'Live') {
      this.showLiveServer = true;
    }


  }


  bulkDocArray = [];
  loginrespose;

  ngAfterViewInit() {
    // this.cdr.detectChanges();
  }
  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.dataSynced) this.dataSynced.unsubscribe();

    if (this.answerSheetLengthdataSynced) this.answerSheetLengthdataSynced.unsubscribe();
    if (this.shelfBookSubscription) this.shelfBookSubscription.unsubscribe();
  }

  updateanswerSheetLength(length) {

    this.answerSheetLength = length;

  }

  userdata(data) {
    this.loginUserDetails = data;
  }


  switchBottomTabs(index, name, evt) {

    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable(name.code);

    if (isFeatureAvailable == 'false') {
      //  this.openSnackBar("This Feature is Not Enabled", '');
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }

    this.selectedTabTypeIndex = 0;
    this.selectedBottomTabIndex = index;
    this.selectedTabList = 0;
    this.left_headerElements = this.data[name.name];
    if (this.selectedBottomTabIndex != 0) {
      this.receivedMessage('', '');
      this.answerSheetLength = 0;
    }
    // this.listOfElememts = this.left_headerElements[0].content;

    // this.navigatePage(0, this.listOfElememts[0], evt, '');
    // this.shelfPouchService.deleteAllDocs();
    // this.shelfPouchService.removeBookIdsFromRecents();
  }

  loadStoreComponent() {

    // if (!this.isLoggedIn) {
    //   this.openSnackBar('please login', '');
    //   return;
    // }
    // var temp = JSON.parse(localStorage.nasResponse);
    //  if (!temp.signIn.user.isRedeemedMapped) {
    //   this.openSnackBar('please enter Redeem', '');
    // }
    // else {

    // document.getElementsByClassName('showApploader')[0].classList.add('hideApploader');
    this.data.appendComponentsToApp('store');
    // }
  }

  logOut() {
    this.data.appendComponentsToApp('shelf');
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snack-bar-color'],
      duration: 2000,
    });
  }


  // startReplicationTo() {

  //   this.shelfPouchService.startReplicationTo();
  // }

  receivedMessage(event, temp) {

    // this.message = event
    if (event.type == 'All') {
      this.appendComponent = AllComponent;
    }
    else if (event.type == 'My Drive') {
      this.sharedWithMe = false;
      //this.initPicker();
      this.appendComponent = GoogledriveComponent;

    }
    else if (event.type == 'Share with me') {

      gapi.client.load('drive', 'v2')
      this.sharedWithMe = true;
      this.appendComponent = GoogledriveComponent;
      //this.initPicker();
    }

    else if (event.type == 'DropBox' ||event.type == 'OneDrive' ) {
            this.sharedWithMe = false;
            this.appendComponent = DropboxComponent;
          }

    else if (event.type == 'Inbox') {
      this.appendComponent = InboxDetailsComponent;
    }
    else {
      this.appendComponent = BookshelfComponent;
    }

    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.appendComponent);
    let viewContainerRef = this.shelfHost.viewContainerRef;
    viewContainerRef.clear();

    let componentRef = viewContainerRef.createComponent(componentFactory);
    if (event.type == 'Inbox') {

      (<ShelfAppendComponent>componentRef.instance).data =
        {
          'inboxData': event
        };

    }

    else {
      (<ShelfAppendComponent>componentRef.instance).data =
        {
          'this': this,
          'pouchData': event
        };

    }

  }

  receivedMessageForBook(event) {

    this.clcikedBookInfo = event.book;
    this.bookParentInfo = event.data;
    this.onBookClicked = true;

  }

  onBookClick(bookObj) {
    this.data.bookObj = bookObj;
    this.loadComponentsToApp(bookObj);
    if (this.ElectronService.IS_ELECTRON && bookObj.bookCategory == 0) { //Is Electron      
      this.checkBookStatus(bookObj);
    }
    else{
      this.data.isBook = true;
    }
  }
  checkBookStatus(bookObj) {  
    this.data.isBook = false;
    var Book_Path = this.ElectronService.USER_PATH + '/' + bookObj.bId
    if (!this.ElectronService.FS.existsSync(Book_Path)) { //Download Book Is not there  
      this.ElectronService.shelfBookDownload(bookObj);
    }
    else{
      this.data.isBook = true;
    }
  }

  loadComponentsToApp(bookObj) {  
    var self = this;
    this.shelfPouchService.addBooksIntoRecents(bookObj);
    this.shelfPouchService.getbookDataObj(bookObj).then(function (result) {
      self.data.bookDataObj = result;

      if (bookObj.bookType == 8) {
        self.data.appendComponentsToApp('ALB');
      }
      else if (bookObj.bookType == 3 || bookObj.bookType == 2) {
        self.data.appendComponentsToApp('ELE');
      }
      else {
        self.data.appendComponentsToApp('EBE');
      }
    });
  }

  setDataObj(obj) {


    // this.bookDataObj = obj;

  }



  showLoginPopup(popupParams, ev, width, height, arrposition) {

    ev.stopPropagation();
    popupParams.loadDirective = LoginComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.arrowPos = arrposition;
    popupParams.direction = "top";
  }

  toggleAppSearchbar() {

    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Shelf_Search');
    if (isFeatureAvailable == 'false') {
      //  this.openSnackBar("This Feature is Not Enabled", '');
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }

    this.toggleAppSearch = !this.toggleAppSearch
  }

  toggleAppServers() {
    this.showLiveServer = !this.showLiveServer;
    if (this.showLiveServer) localStorage.appServer = 'Live';
    else localStorage.appServer = 'Dev';
  }

  onLoginCallback(evt){
this.userdata = evt.userData;
this.userDetails = this.userdata;
this.loginUserDetails = this.userDetails;
this.isLoggedIn = evt.isLoggedIn
  }

  deleteAllDocs() {
    this.shelfPouchService.deleteAllDocs();
  }
  displaySearchAreaOnEnter(ev, name) {

    var myCompThis = parent.window.document['mycompthis'];
    myCompThis.displaySearchRecords(name);

  }

  clearShelfSearchRecords(ev){
    this.searchingBook = '';
    this.displaySearchAreaOnEnter(ev,this.searchingBook)
  }

}



// WEBPACK FOOTER //
// ./src/app/shelf/shelf.component.ts